module.exports = __webpack_public_path__ + "static/media/blom-pysanky-53.813c3576.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-53.jpg
// module id = 3743
// module chunks = 14